<template>
  <div>
    <form v-if="!success" @submit.prevent="login" class="flex flex-col text-left">
      <label>Email</label>
      <input ref="email" type="email" v-model="email" required class="border rounded p-1 mb-2" />

      <button class="rounded bg-blue-400 text-white font-bold p-2 hover:bg-blue-500 transition">
        Confirmer
      </button>
    </form>

    <div v-if="success">Vérifiez vos emails</div>
  </div>
</template>

<script>
import * as api from '../api';

export default {
  data() {
    return {
      success: false,
      email: 'denishacquin@gmail.com',
    };
  },

  mounted() {
    this.$refs.email.focus();
  },

  methods: {
    async login() {
      const result = await api.requestLoginEmail(this.email);
      this.success = true;
    },
  },
};
</script>
